import { render, staticRenderFns } from "./modelSet.vue?vue&type=template&id=0ce80084&scoped=true"
import script from "./modelSet.vue?vue&type=script&lang=js"
export * from "./modelSet.vue?vue&type=script&lang=js"
import style0 from "./modelSet.vue?vue&type=style&index=0&id=0ce80084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce80084",
  null
  
)

export default component.exports